import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetDetailTicket } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (ticketno) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    const url = ApiUrl2 + '/helpdesk-getticketdetail';
    const formbody = new FormData();
    formbody.append('ticket-no', ticketno );

    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : formbody
    };  

    const response = await doFetch(url,argument)
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('data');
    }

    dispatch({ type: GetDetailTicket, data: fromJS(data) });
};